import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { Link } from 'expo-router';
import { LabelText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <View style={styles.container}>
      <LabelText style={styles.text} bold>
        SG Order
      </LabelText>

      <LabelText>Expo Router</LabelText>

      <View style={styles.ctasContainer}>
        <Link href="/menu" asChild>
          <TouchableOpacity style={styles.cta}>
            <LabelText sizeMatch={['12']} style={styles.ctaText}>
              Navigate to menu
            </LabelText>
          </TouchableOpacity>
        </Link>

        <Link href="/loyalty" asChild>
          <TouchableOpacity style={styles.cta}>
            <LabelText sizeMatch={['12']} style={styles.ctaText}>
              Navigate to loyalty
            </LabelText>
          </TouchableOpacity>
        </Link>
      </View>
    </View>
  );
}

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.APP_BACKGROUND,
    padding: theme.spacing['10'],
  },
  text: {
    color: theme.colors.KALE,
  },
  ctasContainer: {
    marginTop: theme.spacing['10'],
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing['2'],
  },
  cta: {
    backgroundColor: theme.colors.KALE,
    borderRadius: theme.radius.large,
    paddingVertical: theme.spacing['2'],
    paddingHorizontal: theme.spacing['3'],
  },
  ctaText: {
    color: theme.colors.WHITE,
  },
});
